// Autogenerated file
export const parcelRelationTypesEnum = {
    Bid: "Bid",
    DistributionBid: "DistributionBid",
};
export const parcelRelationTypes = [
    { label: "Заявка", value: "Bid" },
    { label: "Заказ", value: "DistributionBid" },
];
